<template>
  <v-col lg="8" align="center">
    <br/><br/>
    <v-row>
      <v-col align="start">
        <h1 class="mb-4">Choose service type 
          <a style="font-size: 22px; font-weight: lighter;" class="primary--text" @click="show = !show"> - {{show ? 'Hide Info' : 'Service type info?'}} </a>
        </h1>
      </v-col>
    </v-row>
    <v-row no-gutters class="btn-group" justify="center">
      <v-col cols="4">
        <v-btn 
          depressed
          class="primary btn"  
          height="45"
          style="border-radius: 30px;"
          v-on:click="goBack">Go back
        </v-btn>
      </v-col>
    </v-row>
    <br/>
    <v-container>
      <v-row class="mb-2" v-for="service in services" v-bind:key="service.key" justify="center">
        <v-card elevation="10" width="400" v-on:click="service.onClick" :class="service.isSelected ? 'grey darken-3 primary--text' : 'white black--text'">
          <v-container @click="scrollToTop()">
            <v-row justify="center">
              <v-col align="center">
                <p>{{ service.name }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-row>
      <v-row v-if="show">
        <v-col>
          <Service/>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import Service from '@/components/fast-quote/Service.vue';
export default {
  name: "ServiceType",
  props: {
    proceed: Function,
    vehicles: Array,
    goBack: Function
  },
  components: {
    Service
  },
  data() {
    return {
      yardSelected: false,
      selectedServiceType: {},
      services: [],
      canProceed: false,
      show: false
    }
  },
  watch: {
    selectedServiceType () {
      this.canProceed = true;
    }
  },
  methods: {
    scrollToTop(){
      setTimeout(() => {
        scroll(0, 0);
      }, 0)
    },
    selectService(service) {
      this.services.forEach( s =>  {
        s.isSelected = s.key === service;
        if (s.isSelected) {
          this.selectedServiceType = s;
          this.proceed(this.selectedServiceType);
        }
      });
    }
  },
  mounted() {
    this.vehicles.forEach( (v) => {
      this.services.push( {...v, isSelected: false, image: require(`../../assets/4-yards.svg`), onClick: () => this.selectService(v.key) });
    });
  }
}
</script>

<style scoped>
.btn{
  width: 200px;
}
@media screen and (max-width: 550px){
  .btn-group{
    display: block;
    text-align: start;
  }
  .btn{
    margin-bottom: 0.5cm;
  }

}
</style>